<template>
  <li class="form-group form-check form-check-search">
    <input
      type="checkbox"
      class="form-check-input"
      :id="facet.key"
      tabindex="0"
      @change="onChange"
      :checked="facet.checked"
      :aria-checked="facet.checked"
    />
    <label class="form-check-label" :for="facet.key" tabindex="-1">
      {{ facet.key
      }}<span class="badge"
        >{{ facet.count }}<span class="sr-only"> {{ i18n.resultsFound }}</span></span
      >
    </label>
  </li>
</template>

<script>
export default {
  props: {
    facet: {
      type: Object,
      required: true,
    },
  },
  methods: {
    /**
     * Notify the store that the faced has been checked
     */
    onChange(event) {
      this.$store.dispatch('setFacet', { key: this.facet.key, checked: event.target.checked });
    },
  },
  data: function() {
    return {
      i18n: {
        resultsFound: this.$t(`resultsFound`),
      },
    };
  },
};
</script>

<style lang="less">
@import 'facette.less';
</style>
